// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2OKZP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3JTJ9"};